import React from "react";
import { observer } from "mobx-react-lite";

import "./SnackbarNotifications.scss";
import { Success, Error } from "../svg/svgImageList";
import Svg from "../svg/Svg";
import useThemeService from "../../services/theme-service/ThemeService";
import { translationService } from "../../services/translation/TranslationService";
import { SnackbarNotification } from "../../services/notifications/SnackbarNotificationsService";

export default observer(function SnackbarNotification({
  status,
  messageKey,
  messageContext,
  identifier,
}: SnackbarNotification) {
  const { themeClass } = useThemeService();

  if (!status) return null;

  let containerCss = themeClass(["status-success"], ["hide"]);
  let icon = {
    svg: Success,
    width: 30,
    height: 30,
    className: themeClass(["icon-success"]),
  };

  if (status === "error") {
    containerCss = themeClass(["status-error"], ["hide"]);
    icon = { ...icon, svg: Error, className: themeClass(["icon-error"]) };
  }

  return (
    <div key={identifier} className={containerCss}>
      <div className={themeClass(["info"])}>
        <Svg {...icon} />
        <span>
          {messageContext
            ? translationService.translate(messageKey, messageContext)
            : translationService.translate(messageKey)}
        </span>
      </div>
    </div>
  );
});
